export default (siteUrl) => [
  { name: `description`, content: `Ecco Fleet Audit, il servizio di Edison che favorisce la mobilità sostenibile attraverso l'analisi delle flotte e la graduale elettrificazione.`},
  //fb
  { property: 'og:type', content: 'website'},
  { property: 'og:url', content: 'https://metatags.io/'},
  { property: 'og:title', content: `L'e-mobility per il business`},
  { property: 'og:description', content: `Ecco Fleet Audit, il
  servizio di Edison che favorisce la mobilità sostenibile attraverso
  l'analisi delle flotte e la graduale elettrificazione.`},
  { property: 'og:image', content: `https://stories.efficienzaenergetica.edison.it/fleet-audit/Edison_Thumbnail.png`},

  //twitter
  { property: 'twitter:card', content: `${siteUrl}/summary_large_image.png`},
  { property: 'twitter:url', content: 'https://metatags.io/'},
  { property: 'twitter:title', content: `L'e-mobility per il business`},
  { property: 'twitter:description', content: `Ecco Fleet Audit, il servizio di Edison che favorisce la mobilità sostenibile attraverso l'analisi delle flotte e la graduale elettrificazione.`},
  { property: 'twitter:image', content: `https://stories.efficienzaenergetica.edison.it/fleet-audit/Edison_Thumbnail.png`},
]
